import pkg from '../package.json'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const GA_TRACKING_ID = config.public.gaTrackingId

  // 取得顯示模式
  const getDisplayMode = () => {
    // TWA 檢測
    if (document?.referrer && document.referrer.startsWith('android-app://')) {
      return 'twa'
    }

    // iOS standalone 檢測
    if (!!navigator && 'standalone' in navigator && navigator.standalone) {
      return 'standalone'
    }

    // 標準 media query 檢測
    if (window?.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
      return 'standalone'
    }

    return 'browser'
  }

  // 初始化 Google Analytics
  window.dataLayer = window.dataLayer || []

  function gtag() {
    window.dataLayer.push(arguments)
  }

  gtag('js', new Date())

  if (GA_TRACKING_ID) {
    gtag('config', GA_TRACKING_ID, {
      pwa_version: `v${pkg.version}`,
      display_mode: getDisplayMode(),
    })
  }

  return {
    provide: {
      gtag,
    },
  }
})
